<template>
  <div class="app">
    <mt-loadmore
      :bottom-method="ChangeQueryRecord"
      :autoFill="false"
      ref="loadmore"
    >
      <div style="height: 15px"></div>
      <div class="centBox" v-for="(item, index) in tateData" :key="index">
        <div class="centtl fr">
          <span class="mendian">{{ item.SHPNAME }}</span>
          <span class="mony fr">￥{{ item.AMT }}</span>
        </div>
        <span class="shijian">{{ item.DOCDATE }}</span>
      </div>
      <div class="none_list" v-if="tateData.length == 0">
        <img class="main_headimg" src="/static/image/xiaofeijilu.png" />
        <p class="main_text">还没有消费记录哦！</p>
      </div>
      <div>
        <Return></Return>
      </div>
      <!-- <loading v-if="load"></loading> -->
      <div slot="bottom" class="mint-loadmore-bottom">
        <span v-show="load">松手释放↑</span>

        <!-- <span v-show="scrollFalse">没有更多数据啦！</span> -->
      </div>
    </mt-loadmore>
  </div>
</template>
<script>
export default {
  name: 'consumptionRecord',
  data() {
    return {
      load: false,
      appcode: '',
      code: '',
      page: 1,
      tateData: [],
      scrollFalse: true,
      vipno: '',
    }
  },
  mounted() {
    this.appcode = localStorage.getItem('appcode')
    this.code = localStorage.getItem('code')
    this.ChangeQueryRecord(this.page)
  },
  methods: {
    ChangeQueryRecord() {
      if (!this.scrollFalse) {
        return
      }
      this.load = true
      this.scrollFalse = false
      this.vipno = localStorage.getItem('VIPNO')
      const companyID = localStorage.getItem('companyID')
      this.RequestVIP(
        `h5/vip/queryRecord/v2?openID=${this.code}&vipno=${this.vipno}&CompanyID=${companyID}&size=20&page=${this.page}`,
        // { appcode: this.appcode, code: this.code, num: 10, page: val },
        (r) => {
          if (r.data.data.table1 != undefined && r.data.data.table1.length) {
            this.tateData = [...this.tateData, ...r.data.data.table1]
            this.scrollFalse = true
            this.page += 1
          } else {
            this.scrollFalse = false
          }
          console.log(r.data.data.table1)
          this.load = false
          this.$refs.loadmore.onBottomLoaded()
        },
        (err) => {
          console.log(err)
          this.load = false
          this.scrollFalse = true
        }
      )
    },
  },
}
</script>
<style scoped>
.app {
  width: 100%;
  height: 98vh;
  /* background: #f2553d; */
  overflow: scroll;
}
.none_list {
  position: fixed;
  top: 40%;
  left: 42%;
  text-align: center;
}
.main_headimg {
  width: 40px;
  height: 40px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.centBox {
  border-bottom: 0.5px solid #e0e0e0;
  height: 50px;
  background: #fff;
  color: #757575;
}
.centtl {
  width: 95%;
  height: 30px;
  line-height: 30px;
}
.mendian {
  color: #212121;
  font-size: 11px;
}
.mony {
  color: #f2553d;
  margin-right: 5%;
  font-size: 9px;
}
.shijian {
  margin-left: 5%;
  font-size: 9px;
}
</style>



// WEBPACK FOOTER //
// src/consumptionRecord/index.vue